import {
    GET_ALL_USERS,
    GET_ALL_SELLERS,
    GET_ALL_BIDDING_USERS,
    GET_SINGLE_USER,
    GET_DASHBOARD_USER,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_SINGLE_OWNER,
    GET_CUSTOM_SINGLE_USER,
} from './userTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_USERS:
            return {
                ...state,
                all_users: action.payload,
            }

        case GET_ALL_SELLERS:
            return {
                ...state,
                all_sellers: action.payload,
            }

        case GET_ALL_BIDDING_USERS:
            return {
                ...state,
                all_bidding_users: action.payload,
            }
        case GET_SINGLE_USER:
            return {
                ...state,
                single_user: action.payload,
            }
        case GET_CUSTOM_SINGLE_USER:
            return {
                ...state,
                single_custom_user: action.payload,
            }
        case GET_DASHBOARD_USER:
            return {
                ...state,
                search_alldashboardproducts: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_SINGLE_OWNER:
            return {
                ...state,
                single_owner: action.payload,
            }
        default:
            return state
    }
}
